module.exports = __webpack_public_path__ + "8a0ca642abdb76c8aa395fd54407e2e4.svg";